import axios from 'axios';
import config from '../config';
import jwt from "jsonwebtoken";
import { toast } from 'react-toastify';
import { push,go,replace } from 'connected-react-router';
// import Errors from '../components/FormItems/error/errors';

export const AUTH_FAILURE = 'AUTH_FAILURE';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const RESET_REQUEST = 'RESET_REQUEST';
export const RESET_SUCCESS = 'RESET_SUCCESS';
export const PASSWORD_RESET_EMAIL_REQUEST = 'PASSWORD_RESET_EMAIL_REQUEST';
export const PASSWORD_RESET_EMAIL_SUCCESS = 'PASSWORD_RESET_EMAIL_SUCCESS';
export const AUTH_INIT_SUCCESS = 'AUTH_INIT_SUCCESS';
export const AUTH_INIT_ERROR = 'AUTH_INIT_ERROR';
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';

async function findMe() {
}

export function authError(payload) {
  return {
    type: AUTH_FAILURE,
    payload,
  };
}

export function doInit() {
  return async (dispatch) => {
    let currentUser = null;
    {
      try {
        let token = localStorage.getItem('token_bigbrand');
        if (token) {
          currentUser = await findMe();
        }
        dispatch({
          type: AUTH_INIT_SUCCESS,
          payload: {
            currentUser,
          },
        });
      } catch (error) {
        // Errors.handle(error);

        dispatch({
          type: AUTH_INIT_ERROR,
          payload: error,
        });
      }
    }
  }
}

export function logoutUser() {
    return (dispatch) => {
        dispatch({
          type: LOGOUT_REQUEST,
        });
        localStorage.removeItem('token_bigbrand');
        localStorage.removeItem('user_bigbrand');
        axios.defaults.headers.common['Authorization'] = "";
        dispatch({
          type: LOGOUT_SUCCESS,
        });
      // dispatch(push('/login'));
      window.location.href = "/"
    };
}

export function receiveToken(data) {
    return (dispatch) => {
        var token = data['token'];
        var user = data['user']

        localStorage.setItem('token_bigbrand', token);
        localStorage.setItem('user_bigbrand', JSON.stringify(user));
        axios.defaults.headers.common['Authorization'] = "Bearer " + token;
        dispatch({
          type: LOGIN_SUCCESS
        });
        // window.location.href = "/myorders"
        // dispatch(push('/myorders'));
    }
}

export function loginUser(creds) {
    return (dispatch) => {
      {
        dispatch({
          type: LOGIN_REQUEST,
        });
        if (creds.social) {
          window.location.href = config.baseURLApi + "/auth/signin/" + creds.social + '?app=' + config.redirectUrl;
        } else if (creds.email.length > 0 && creds.password.length > 0) {
          axios.post("/users/login", creds).then(res => {
            const result = res.data;
            if(result.status == "success"){
              dispatch(receiveToken(result.data));
              dispatch(doInit());
              
              var user = result.data['user']
              if(user['role'] == 'admin')
                window.location.href = "/admin/myorders"
              else
                window.location.href = "/myorders"
            }
            else{
              dispatch(authError('The username or password entered is not correct.'));
            }
          }).catch(err => {
            dispatch(authError('Something was wrong. Try again '));
          })
        } else {
          dispatch(authError('Something was wrong. Try again '));
        }
      }
    };
}

export function resetUser(creds) {
  return (dispatch) => {
    {
      if (creds.email.length > 0) {
        axios.post("/users/forgetpassword", creds).then(res => {
          const result = res.data;
          if(result.status == "success"){
            toast.success("We sent new password to your email");
          }
          else{
            dispatch(authError(result.data));
          }
        }).catch(err => {
          dispatch(authError('Something was wrong. Try again '));
        })
      } else {
        dispatch(authError('Something was wrong. Try again '));
      }
    }
  };
}



export function verifyEmail(token) {
  return(dispatch) => {
    if (!config.isBackend) {
      dispatch(push('/login'));
    } else {
      axios.put("/auth/verify-email", {token}).then(verified => {
        if (verified) {
          toast.success("Your email was verified");
        }
      }).catch(err => {
        toast.error(err.response.data);
      }).finally(() => {
        dispatch(push('/login'));
      })
    }
  }
}

export function resetPassword(token, password) {
  return (dispatch) => {
    if (!config.isBackend) {
      dispatch(push('/login'));
    } else {
      dispatch({
        type: RESET_REQUEST,
      });
      axios.put("/auth/password-reset", {token, password}).then(res => {
          dispatch({
            type: RESET_SUCCESS,
          });
          toast.success("Password has been updated");
        dispatch(push('/login'));
      }).catch(err => {
        dispatch(authError(err.response.data));
      })
    }
  }
}

export function sendPasswordResetEmail(email) {
  return (dispatch) => {
    if (!config.isBackend) {
      dispatch(push('/login'));
    } else {
      dispatch({
        type: PASSWORD_RESET_EMAIL_REQUEST,
      });
      axios.post("/auth/send-password-reset-email", {email}).then(res => {
        dispatch({
          type: PASSWORD_RESET_EMAIL_SUCCESS,
        });
        toast.success("Email with resetting instructions has been sent");
        dispatch(push('/login'));
      }).catch(err => {
        dispatch(authError(err.response.data));
      })
    }
  }
}

export function registerUser(creds) {
  return (dispatch) => {
    {
      dispatch({
        type: REGISTER_REQUEST,
      });
  
      if (creds.email.length > 0 && creds.password.length > 0) {
        axios.post("/users/register", creds).then(res => {
          const result = res.data;
          if(result.status == "success"){
            // toast.success("You registerd your account");
            // window.location.href='/login-page';
            dispatch(loginUser(creds))
          }
          else{            
            var errors = res.data.data;
            if(errors){
              for(var loop in errors){
                var error = errors[loop];
                if(error){                  
                  for(var loop1 in error){
                      dispatch(authError(loop+": "+error[loop1]));
                      break;
                  }
                }
                break;
              }
            }
            // toast.error(res.data.data);
          }
        }).catch(err => {
          dispatch(authError('Something was wrong. Try again '));
        })
      } else {
        dispatch(authError('Something was wrong. Try again '));
      }
    }
  };
}